var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.112 6H111.577V73.4258H134.113V50.8477H154.729V73.4258H177.265V6H154.728V28.2656H134.112V6Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187.061 28.3594H206.9L206.901 73.4258H229.438V28.3594H249.287V6H187.061V28.3594Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M259.163 6H282.662L297.117 29.6914L311.558 6H335.065V73.4258H312.622V40.0059L297.117 63.9795H296.729L281.214 40.0059V73.4258H259.163V6Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M368.824 6H346.281V73.4258H400.517V51.1387H368.824V6Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.855 465.841L78.6182 104.262H432.851L400.579 465.784L255.518 506L110.855 465.841Z",
    fill: "#E44D26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.734 475.261L372.951 442.764L400.529 133.826H255.734V475.261Z",
    fill: "#F16529"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M197.053 267.931H255.734V312.276H156.496L144.535 178.173H255.734V222.52H193L197.053 267.931Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M255.54 383.154L255.734 383.103V429.241L255.53 429.298L164.69 404.08L158.478 334.45H202.994L206.151 369.818L255.54 383.154Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M255.581 178.173H366.669L362.698 222.52H255.581V178.173Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M255.581 312.276V267.931H358.663L357.581 279.839L346.493 404.08L255.581 429.276V383.14L305.041 369.79L310.188 312.276H255.581Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/HTML5.a8f96029decb54b29b0a73bceb111de2.svg";
export { ForwardRef as ReactComponent };